import { useState } from "react";

import { searchCustomer } from "src/apis/customerApi";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";

import {
	defaultTQC1060_R01Filter,
	useTQC1060_R01Store,
} from "./Store_TQC1060_R01";

const INOUT_CLASS_TARGETS = ["110", "170"];

export const SearchSection_TQC1060_R01 = () => {
	const { TQC1060_R01Filter, setTQC1060_R01Filter } = useTQC1060_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { compCdList, inoutClassList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const customerFocusId = "tqc1060_customCd_search";
	const itemFocusId = "tqc1060_itemCd_search";
	const inoutClassOptions = inoutClassList.filter((code) =>
		INOUT_CLASS_TARGETS.includes(code.minorCd),
	);

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "customCd",
			category: "거래처",
			focusId: customerFocusId,
			responseMapping: { customCd: "customCd", customNm: "customNm" },
			searchFunction: async (searchText: string) => {
				const response = await searchCustomer(searchText);
				return response.data.data.find((value) => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: TQC1060_R01Filter.customCd || "",
				customNm: TQC1060_R01Filter.customNm || "",
			}),
		},
		{
			fieldName: "itemCd",
			category: "품목",
			focusId: itemFocusId,
			responseMapping: { itemCd: "itemCd", itemNm: "itemNm" },
			searchFunction: async (searchText: string) => {
				const response = await getItemPopupList(searchText, "", "", "");
				return response.data.data.find((value) => value.itemCd === searchText);
			},
			extraFilter: () => ({
				itemCd: TQC1060_R01Filter.itemCd || "",
				itemNm: TQC1060_R01Filter.itemNm || "",
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC1060_R01Filter,
		setEditData: setTQC1060_R01Filter,
		defaultData: defaultTQC1060_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "TQC1060_R01_search",
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={TQC1060_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(compCd) => setTQC1060_R01Filter({ compCd })}
			/>
			<SearchDateRangeForm
				label="입고기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC1060_R01Filter.dateRange}
				setDateRange={(dateRange) => setTQC1060_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm<SysCodeDto>
				label="입고구분"
				value={TQC1060_R01Filter.inoutClass}
				optionList={inoutClassOptions}
				onChangeItem={(selectedItem) =>
					setTQC1060_R01Filter({ inoutClass: selectedItem?.minorCd || "" })
				}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={TQC1060_R01Filter.customCd}
				valueLabel={TQC1060_R01Filter.customNm}
				handleFoucsId={customerFocusId}
				onChange={getFieldHandlers("customCd").onChange}
				onDoubleClick={getFieldHandlers("customCd").onDoubleClick}
				onKeyDown={getFieldHandlers("customCd").onEnterKeyDown}
			/>
			<SearchCodeModalForm
				label="품목코드"
				value={TQC1060_R01Filter.itemCd}
				valueLabel={TQC1060_R01Filter.itemNm}
				handleFoucsId={itemFocusId}
				onChange={getFieldHandlers("itemCd").onChange}
				onDoubleClick={getFieldHandlers("itemCd").onDoubleClick}
				onKeyDown={getFieldHandlers("itemCd").onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};
